<template>
  <div class="status_notice">
    <button class="status_notice_btn" @click="popup_notice = !popup_notice">
      <p class="notice_icon"><i class="fas fa-bell"></i></p>
    </button>
    <div
      class="notice_wrapper"
      v-bind:class="{ close: !popup_notice }"
      @click="popup_notice = !popup_notice"
    >
      <div class="notice_content">
        <div class="notice_header">
          <p class="notice_title">通知</p>
          <button class="notice_close_btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <ul>
          <li class="notice_item" v-for="(item,index) in notice" :key="index">
            <a :href="`/${item.data.link}`">
              <div class="notice_kind">
                <i v-if="item.data.kind == 'ranking'" class="fas fa-trophy" style="color: orangered"></i>
                <i
                  v-if="item.data.kind == 'cheer'"
                  class="fas fa-rocket"
                  style="color: darkblue"
                ></i>
                <i v-if="item.data.kind == 'news'" class="fas fa-envelope"></i>
              </div>
              <div class="notice_text">
                {{item.data.message}}
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  props: ["notice"],
  data() {
    return {
      popup_notice: false,
      loading: true,
    };
  },
  computed: {
    noticeWatch() {
      return store.getters.notice;
    }
  },
  watch: {
    noticeWatch() {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss">
.notice {
  &_wrapper {
    &.close {
      transform: translateX(110vw);
      opacity: 0;
    }
    background-color: $fade_color;
    transition: transform 0.3s, opacity 0.3s;
    transform: translateX(0%);
    position: fixed;
    height: 120vh;
    width: 110vw;
    top: -20vh;
    left: -10vw;
    @include zIndex(101);
  }
  &_content {
    position: absolute;
    right: 0;
    top: 20vh;
    width: 380px;
    height: 100%;
    background-color: #fff;
    @include sp {
      width: 100vw;
    }
  }
  &_header {
    padding: 20px 40px 40px 20px;
    background-color: $main_orange;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &_title {
    @include fz(28);
    color: #fff;
    text-shadow: 2px 0px 1px $text_gray;
    font-weight: 500;
  }
  &_close_btn {
    @include icon(40px);
    @include default_button("rotate");
    box-shadow: none;
  }
  &_item {
    a {
      display: inline-block;
      display: flex;
    }
    padding: 20px 0;
    margin: 0 20px;
    border-bottom: 1px solid #000;
  }
  &_kind {
    margin-right: 20px;
    img {
      min-width: 40px;
    }
  }
  &_text {
    text-align: left;
    @include fz(16);
  }
}
</style>